<mat-card appearance="outlined" aria-labelledby="user-assignments-header-title">
    <mat-card-header *ngIf="!hideTitle">
        <mat-card-title id="user-assignments-header-title" class="header-title">
            <h2>Assignments</h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <mat-tab-group [(selectedIndex)]="selectedIndex">
            <mat-tab label="{{ Type.Active }}"></mat-tab>
            <mat-tab label="{{ Type.Pending }}"></mat-tab>
            <mat-tab label="{{ Type.Completed }}"></mat-tab>
            <mat-tab label="{{ Type.Cancelled }}"></mat-tab>
            <mat-tab label="{{ Type.Coordinators }}"></mat-tab>
        </mat-tab-group>

        <ng-container *ngIf="asState(selectedState); let state">
            <mat-progress-bar
                *ngIf="state.isLoading"
                class="tab-progress"
                mode="indeterminate"
                aria-label="assignments progress"
            ></mat-progress-bar>
            <las-assignments-report
                *ngIf="!state.isLoading; else loading"
                [assignments]="state.assignments"
                [user]="user"
            ></las-assignments-report>
        </ng-container>
    </mat-card-content>
</mat-card>

<ng-template #loading>
    <h3>Loading assignments...</h3>
</ng-template>
